<ng-template #offerTextFields let-condition="condition" let-conditionFormGroup="conditionFormGroup">
<div class="offer-text-wrapper" [formGroup]="conditionFormGroup">
  @if (condition === newVehicleCondition) {
          <h4 class="form-section-header">MSRP Offer</h4>
          <div class="p-field p-grid">
            <label for="newMsrpTitle" class="p-col-12 p-md-6 ng-star-inserted">MSRP Title</label>
            <div class="p-col-12 p-md-6">
              <p-select id="newMsrpTitle" [options]="newMsrpTitleOptions" optionLabel="label" optionValue="value" formControlName="msrpTitle"></p-select>
            </div>
          </div>

          <h4 class="form-section-header">Purchase Offer</h4>
          <div class="p-field p-grid">
            <label for="newBuyTitle" class="p-col-12 p-md-6 ng-star-inserted">Buy Title</label>
            <div class="p-col-12 p-md-6">
              <p-select id="newBuyTitle" [options]="buyTitleOptions" optionLabel="label" optionValue="value" formControlName="buyTitle"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newPurchaseAfterText" class="p-col-12 p-md-6 ng-star-inserted">Purchase After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="newPurchaseAfterText" type="text" pInputText formControlName="purchaseAfterText">
            </div>
          </div>

          <h4 class="form-section-header">Savings Offer</h4>
          <div class="p-field p-grid">
            <label for="newSavingsTitle" class="p-col-12 p-md-6 ng-star-inserted">Savings Title</label>
            <div class="p-col-12 p-md-6">
              <input id="newSavingsTitle" type="text" pInputText formControlName="savingsTitle">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newSavingsAfterText1" class="p-col-12 p-md-6 ng-star-inserted">Savings After Text 1</label>
            <div class="p-col-12 p-md-6">
              <input id="newSavingsAfterText1" type="text" pInputText formControlName="savingsAfterText1">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newSavingsAfterText2" class="p-col-12 p-md-6 ng-star-inserted">Savings After Text 2</label>
            <div class="p-col-12 p-md-6">
              <input id="newSavingsAfterText2" type="text" pInputText formControlName="savingsAfterText2">
            </div>
          </div>

          <h4 class="form-section-header">Finance Offer</h4>
          <div class="p-field p-grid">
            <label for="newFinancePaymentAfterText" class="p-col-12 p-md-6 ng-star-inserted">Finance Payment After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="newFinancePaymentAfterText" type="text" pInputText formControlName="financePaymentAfterText">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newShowFinanceAprInOfferSet" class="p-col-12 p-md-6 ng-star-inserted">Show Finance APR in Offer Set</label>
            <div class="p-col-12 p-md-6">
              <p-toggleswitch id="newShowFinanceAprInOfferSet" formControlName="showFinanceAprInOfferSet"></p-toggleswitch>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newShowFinanceDownPaymentInOfferSet" class="p-col-12 p-md-6 ng-star-inserted">Show Finance Down Payment In Offer Set</label>
            <div class="p-col-12 p-md-6">
              <p-toggleswitch id="newShowFinanceDownPaymentInOfferSet" formControlName="showFinanceDownPaymentInOfferSet"></p-toggleswitch>
            </div>
          </div>

          <h4 class="form-section-header">APR Offer</h4>
          <div class="p-field p-grid">
            <label for="newAprPricingTitle" class="p-col-12 p-md-6 ng-star-inserted">Apr Pricing Title</label>
            <div class="p-col-12 p-md-6">
              <p-select id="newAprPricingTitle" [options]="aprPricingTitleOptions" optionLabel="label" optionValue="value" formControlName="aprPricingTitle"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newAprRateAfterText" class="p-col-12 p-md-6 ng-star-inserted">APR Rate After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="newAprRateAfterText" type="text" pInputText formControlName="aprRateAfterText">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newAprTermAfterText" class="p-col-12 p-md-6 ng-star-inserted">APR Term After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="newAprTermAfterText" type="text" pInputText formControlName="aprTermAfterText">
            </div>
          </div>

          <h4 class="form-section-header">Lease Offer</h4>
          <div class="p-field p-grid">
            <label for="newLeaseTitleText" class="p-col-12 p-md-6 ng-star-inserted">Lease Title Text</label>
            <div class="p-col-12 p-md-6">
              <p-select id="newLeaseTitleText" [options]="leaseTitleTextOptions" optionLabel="label" optionValue="value" formControlName="leaseTitleText"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newLeasePaymentAfterText" class="p-col-12 p-md-6 ng-star-inserted">Lease Payment After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="newLeasePaymentAfterText" type="text" pInputText formControlName="leasePaymentAfterText">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newLeaseDownDueAfterText" class="p-col-12 p-md-6 ng-star-inserted">Lease Down/Due After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="newLeaseDownDueAfterText" type="text" pInputText formControlName="leaseDownDueAfterText">
            </div>
          </div>

          <h4 class="form-section-header">Alternate Lease Offer</h4>
          <div class="p-field p-grid">
            <label for="newAlternateLeaseTitle" class="p-col-12 p-md-6 ng-star-inserted">Alternate Lease Title</label>
            <div class="p-col-12 p-md-6">
              <p-select id="newAlternateLeaseTitle" [options]="newAlternateLeaseTitleOptions" optionLabel="label" optionValue="value" formControlName="alternateLeaseTitle"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newAlternateLeasePaymentAfterText" class="p-col-12 p-md-6 ng-star-inserted">Alternate Lease Payment After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="newAlternateLeasePaymentAfterText" type="text" pInputText formControlName="alternateLeasePaymentAfterText">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newAlternateLeaseDownDueAfterText" class="p-col-12 p-md-6 ng-star-inserted">Alternate Lease Down/Due After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="newAlternateLeaseDownDueAfterText" type="text" pInputText formControlName="alternateLeaseDownDueAfterText">
            </div>
          </div>

          <h4 class="form-section-header">CTA Text</h4>
          <div class="p-field p-grid">
            <label for="newInventoryButtonText" class="p-col-12 p-md-6 ng-star-inserted">Inventory Button Text</label>
            <div class="p-col-12 p-md-6">
              <p-select id="newInventoryButtonText" [options]="inventoryButtonTextOptions" optionLabel="label" optionValue="value" formControlName="inventoryButtonText"></p-select>
            </div>
          </div>

          @if (!vehicleAdsEnabled) {
            <h4 class="form-section-header">Math Box</h4>
            <div class="p-field p-grid">
              <label for="newDealerDiscountLabel" class="p-col-12 p-md-6 ng-star-inserted">Dealer Discount Label</label>
              <div class="p-col-12 p-md-6">
                <input id="newDealerDiscountLabel" type="text" pInputText formControlName="dealerDiscountLabel">
              </div>
            </div>
          }

          <h4 class="form-section-header">Tagline/Other Visible Text</h4>
          <div class="p-field p-grid">
            <label for="newShowStockNumber" class="p-col-12 p-md-6">Show Stock Number</label>
            <div class="p-col-12 p-md-6">
              @if (vehicleAdsEnabled) {
                <p-toggleswitch inputId="newShowStockNumber" formControlName="showStockNumber"></p-toggleswitch>
              } @else {
                <span>This setting is only available when Vehicle Ads is enabled.</span>
              }
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newShowVin" class="p-col-12 p-md-6">Show VIN
              <i class="pi pi-info-circle form-item-tooltip"
                 pTooltip="When enabled, the VIN appears beneath the vehicle image on the ad."
                 tooltipPosition="right"></i>
            </label>
            <div class="p-col-12 p-md-6">
              @if (vehicleAdsEnabled) {
                <p-toggleswitch inputId="newShowVin" formControlName="showVin"></p-toggleswitch>
              } @else {
                <span>This setting is only available when Vehicle Ads is enabled.</span>
              }
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newDefaultTagline" class="p-col-12 p-md-6 ng-star-inserted">Default Tagline</label>
            <div class="p-col-12 p-md-6">
              <textarea id="newDefaultTagline" pInputTextarea formControlName="defaultTagline"></textarea>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newTaglineType" class="p-col-12 p-md-6 ng-star-inserted">Tagline Type</label>
            <div class="p-col-12 p-md-6">
              <p-select id="newTaglineType" [options]="taglineTypeOptions" optionLabel="label" optionValue="value" formControlName="taglineType"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newUseDefaultTagline" class="p-col-12 p-md-6 ng-star-inserted">Use Default Tagline</label>
            <div class="p-col-12 p-md-6">
              <p-select id="newUseDefaultTagline" [options]="useDefaultTaglineOptions" optionLabel="label" optionValue="value" formControlName="useDefaultTagline"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="newStaticDisclosureLine" class="p-col-12 p-md-6 ng-star-inserted">Static Disclosure Line</label>
            <div class="p-col-12 p-md-6">
              <input id="newStaticDisclosureLine" type="text" pInputText formControlName="staticDisclosureLine">
            </div>
          </div>
  }
  @if (condition === usedVehicleCondition) {
          <h4 class="form-section-header">Market Value</h4>
          <div class="p-field p-grid">
            <label for="usedMarketValueText" class="p-col-12 p-md-6 ng-star-inserted">Market Value Text</label>
            <div class="p-col-12 p-md-6">
              <p-select id="usedMarketValueText" [options]="usedMarketValueTextOptions" optionLabel="label" optionValue="value" formControlName="marketValueText"></p-select>
            </div>
          </div>

          <h4 class="form-section-header">Purchase Offer</h4>
          <div class="p-field p-grid">
            <label for="usedBuyTitle" class="p-col-12 p-md-6 ng-star-inserted">Buy Title</label>
            <div class="p-col-12 p-md-6">
              <p-select id="usedBuyTitle" [options]="buyTitleOptions" optionLabel="label" optionValue="value" formControlName="buyTitle"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedPurchaseAfterText" class="p-col-12 p-md-6 ng-star-inserted">Purchase After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="usedPurchaseAfterText" type="text" pInputText formControlName="purchaseAfterText">
            </div>
          </div>

          <h4 class="form-section-header">Savings Offer</h4>
          <div class="p-field p-grid">
            <label for="usedSavingsTitle" class="p-col-12 p-md-6 ng-star-inserted">Savings Title</label>
            <div class="p-col-12 p-md-6">
              <input id="usedSavingsTitle" type="text" pInputText formControlName="savingsTitle">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedSavingsAfterText1" class="p-col-12 p-md-6 ng-star-inserted">Savings After Text 1</label>
            <div class="p-col-12 p-md-6">
              <input id="usedSavingsAfterText1" type="text" pInputText formControlName="savingsAfterText1">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedSavingsAfterText2" class="p-col-12 p-md-6 ng-star-inserted">Savings After Text 2</label>
            <div class="p-col-12 p-md-6">
              <input id="usedSavingsAfterText2" type="text" pInputText formControlName="savingsAfterText2">
            </div>
          </div>

          <h4 class="form-section-header">Finance Offer</h4>
          <div class="p-field p-grid">
            <label for="usedFinancePaymentAfterText" class="p-col-12 p-md-6 ng-star-inserted">Finance Payment After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="usedFinancePaymentAfterText" type="text" pInputText formControlName="financePaymentAfterText">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedShowFinanceAprInOfferSet" class="p-col-12 p-md-6 ng-star-inserted">Show Finance APR in Offer Set</label>
            <div class="p-col-12 p-md-6">
              <p-toggleswitch id="usedShowFinanceAprInOfferSet" formControlName="showFinanceAprInOfferSet"></p-toggleswitch>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedShowFinanceDownPaymentInOfferSet" class="p-col-12 p-md-6 ng-star-inserted">Show Finance Down Payment In Offer Set</label>
            <div class="p-col-12 p-md-6">
              <p-toggleswitch id="usedShowFinanceDownPaymentInOfferSet" formControlName="showFinanceDownPaymentInOfferSet"></p-toggleswitch>
            </div>
          </div>

          <h4 class="form-section-header">APR Offer</h4>
          <div class="p-field p-grid">
            <label for="usedAprPricingTitle" class="p-col-12 p-md-6 ng-star-inserted">Apr Pricing Title</label>
            <div class="p-col-12 p-md-6">
              <p-select id="usedAprPricingTitle" [options]="aprPricingTitleOptions" optionLabel="label" optionValue="value" formControlName="aprPricingTitle"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedAprRateAfterText" class="p-col-12 p-md-6 ng-star-inserted">APR Rate After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="usedAprRateAfterText" type="text" pInputText formControlName="aprRateAfterText">
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedAprTermAfterText" class="p-col-12 p-md-6 ng-star-inserted">APR Term After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="usedAprTermAfterText" type="text" pInputText formControlName="aprTermAfterText">
            </div>
          </div>

          <h4 class="form-section-header">Lease Offer</h4>
          <div class="p-field p-grid">
            <label for="usedLeaseTitleText" class="p-col-12 p-md-6 ng-star-inserted">Lease Title Text</label>
            <div class="p-col-12 p-md-6">
              <p-select id="usedLeaseTitleText" [options]="usedLeaseTitleTextOptions" optionLabel="label" optionValue="value" formControlName="leaseTitleText"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedLeasePaymentAfterText" class="p-col-12 p-md-6 ng-star-inserted">Lease Payment After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="usedLeasePaymentAfterText" type="text" pInputText formControlName="leasePaymentAfterText">
            </div>
          </div>

          <h4 class="form-section-header">Alternate Lease Offer</h4>
          <div class="p-field p-grid">
            <label for="usedAlternateLeaseTitle" class="p-col-12 p-md-6 ng-star-inserted">Alternate Lease Title</label>
            <div class="p-col-12 p-md-6">
              <p-select id="usedAlternateLeaseTitle" [options]="usedAlternateLeaseTitleOptions" optionLabel="label" optionValue="value" formControlName="alternateLeaseTitle"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedAlternateLeasePaymentAfterText" class="p-col-12 p-md-6 ng-star-inserted">Alternate Lease Payment After Text</label>
            <div class="p-col-12 p-md-6">
              <input id="usedAlternateLeasePaymentAfterText" type="text" pInputText formControlName="alternateLeasePaymentAfterText">
            </div>
          </div>

          <h4 class="form-section-header">CTA Text</h4>
          <div class="p-field p-grid">
            <label for="usedInventoryButtonText" class="p-col-12 p-md-6 ng-star-inserted">Inventory Button Text</label>
            <div class="p-col-12 p-md-6">
              <p-select id="usedInventoryButtonText" [options]="inventoryButtonTextOptions" optionLabel="label" optionValue="value" formControlName="inventoryButtonText"></p-select>
            </div>
          </div>

          @if (!vehicleAdsEnabled) {
            <h4 class="form-section-header">Math Box</h4>
            <div class="p-field p-grid">
              <label for="usedDealerDiscountLabel" class="p-col-12 p-md-6 ng-star-inserted">Dealer Discount Label</label>
              <div class="p-col-12 p-md-6">
                <input id="usedDealerDiscountLabel" type="text" pInputText formControlName="dealerDiscountLabel">
              </div>
            </div>
          }

          <h4 class="form-section-header">Tagline/Other Visible Text</h4>
          <div class="p-field p-grid">
            <label for="usedShowStockNumber" class="p-col-12 p-md-6">Show Stock Number</label>
            <div class="p-col-12 p-md-6">
              @if (vehicleAdsEnabled) {
                <p-toggleswitch inputId="usedShowStockNumber" formControlName="showStockNumber"></p-toggleswitch>
              } @else {
                <span>This setting is only available when Vehicle Ads is enabled.</span>
              }
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedShowVin" class="p-col-12 p-md-6">Show VIN
              <i class="pi pi-info-circle form-item-tooltip"
                 pTooltip="When enabled, the VIN appears beneath the vehicle image on the ad."
                 tooltipPosition="right"></i>
            </label>
            <div class="p-col-12 p-md-6">
              @if (vehicleAdsEnabled) {
                <p-toggleswitch inputId="usedShowVin" formControlName="showVin"></p-toggleswitch>
              } @else {
                <span>This setting is only available when Vehicle Ads is enabled.</span>
              }
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedDefaultTagline" class="p-col-12 p-md-6 ng-star-inserted">Default Tagline</label>
            <div class="p-col-12 p-md-6">
              <textarea id="usedDefaultTagline" pInputTextarea formControlName="defaultTagline"></textarea>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedTaglineType" class="p-col-12 p-md-6 ng-star-inserted">Tagline Type</label>
            <div class="p-col-12 p-md-6">
              <p-select id="usedTaglineType" [options]="taglineTypeOptions" optionLabel="label" optionValue="value" formControlName="taglineType"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedUseDefaultTagline" class="p-col-12 p-md-6 ng-star-inserted">Use Default Tagline</label>
            <div class="p-col-12 p-md-6">
              <p-select id="usedUseDefaultTagline" [options]="useDefaultTaglineOptions" optionLabel="label" optionValue="value" formControlName="useDefaultTagline"></p-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="usedStaticDisclosureLine" class="p-col-12 p-md-6 ng-star-inserted">Static Disclosure Line</label>
            <div class="p-col-12 p-md-6">
              <input id="usedStaticDisclosureLine" type="text" pInputText formControlName="staticDisclosureLine">
            </div>
          </div>
  }
</div>
</ng-template>

<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3 settings-side-nav">
      <p-panelMenu [model]="settingsSideNav"></p-panelMenu>
    </div>
    <p-panel class="p-col offer-text-settings-wrapper">
      <ng-template pTemplate="header">
        <div class="panel-header-content">
          <h2>Offer Sets</h2>
          <button pButton class="p-button-success save-button" label="Save"
                  [disabled]="getSaveButtonDisabled() || isSaving"
                  [loading]="isSaving"
                  (click)="saveSettings()"></button>
        </div>
      </ng-template>
      <p-tabs [value]="newVehicleCondition">
        <p-tablist>
          <p-tab [value]="newVehicleCondition">New</p-tab>
          <p-tab [value]="usedVehicleCondition">Used</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="newVehicleCondition">
            <ng-container *ngTemplateOutlet="offerTextFields; context: { condition: newVehicleCondition, conditionFormGroup: newConditionFormGroup }"></ng-container>
          </p-tabpanel>
          <p-tabpanel [value]="usedVehicleCondition">
            <ng-container *ngTemplateOutlet="offerTextFields; context: { condition: usedVehicleCondition, conditionFormGroup: usedConditionFormGroup }"></ng-container>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </p-panel>
  </div>
</p-panel>
<p-dialog
  header="Save Offer Text Settings"
  [(visible)]="showSaveConfirmDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false">
  <p>Save stores these settings without updating existing Offer Sets. Save &amp; Sync stores them and starts or schedules an update for existing Offer Sets.</p>
  <ng-template pTemplate="footer">
    <div class="offer-text-confirm-dialog-footer">
      <button
        pButton
        type="button"
        label="Save"
        class="p-button-success"
        [disabled]="isSaving"
        (click)="onSaveConfirmed()">
      </button>
      <button
        pButton
        type="button"
        label="Save & Sync"
        class="p-button-secondary"
        [disabled]="isSaving"
        (click)="onSaveAndSyncConfirmed()">
      </button>
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-danger"
        [disabled]="isSaving"
        (click)="onSaveConfirmCancelled()">
      </button>
    </div>
  </ng-template>
</p-dialog>
<auto-footer></auto-footer>
